import React from "react";
import styled, { keyframes } from "styled-components";
import { Container } from "../components/ui/Container";
import { colors, media } from "../theme";

const items = [
  "Licensed Money Lender Uganda",
  "P2P Lending Marketplace",
  "Mobile money credit scoring",
  "Principal guaranteed",
  "70%+ Women led MSMEs",
  "98% Repayment rate",
  "Built in Kampala",
  "USSD coming soon",
];

export const Marquee = () => (
  <Wrap>
    <Container>
      <Track>
        <Row>
          {[...items, ...items].map((t, i) => (
            <Item key={i}>{t}<Dot /></Item>
          ))}
        </Row>
      </Track>
    </Container>
  </Wrap>
);

const Wrap = styled.div`
  background: white;
  border-bottom: 1px solid ${colors.line};
  padding: 18px 0;
`;

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const Track = styled.div`
  overflow: hidden;
  mask-image: linear-gradient(90deg, transparent, black 8%, black 92%, transparent);
`;

const Row = styled.div`
  display: inline-flex;
  gap: 36px;
  animation: ${scroll} 40s linear infinite;
  white-space: nowrap;
`;

const Item = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 36px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${colors.inkSoft};
  ${media.sm} { font-size: 11.5px; gap: 24px; }
`;

const Dot = styled.span`
  width: 5px; height: 5px; border-radius: 50%;
  background: ${colors.brand};
`;
